module.exports = __webpack_public_path__ + "static/media/kesica_2_in1_zaproveru.0be8399a.jpg";